import { render, staticRenderFns } from "./Fixed_popup.vue?vue&type=template&id=33fcccbe&"
import script from "./Fixed_popup.vue?vue&type=script&lang=js&"
export * from "./Fixed_popup.vue?vue&type=script&lang=js&"
import style0 from "./Fixed_popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33fcccbe')) {
      api.createRecord('33fcccbe', component.options)
    } else {
      api.reload('33fcccbe', component.options)
    }
    module.hot.accept("./Fixed_popup.vue?vue&type=template&id=33fcccbe&", function () {
      api.rerender('33fcccbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fixed_popup.vue"
export default component.exports